import React from "react";
import { useNavigate } from "react-router-dom";
import { CardDemoImg } from "../../constant/imagePath";
import Button from "../Button/Button";
import classes from "./FeaturedCollectionCard.module.css";

function FeaturedCollectionCard({
  data = {
    image: CardDemoImg,
    title: "Best Basketball",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua et dolore magna aliqua et dolore magna aliqua et dolore magna aliqua.",
  },
  on,
  onClick,
}) {
  const navigate = useNavigate();

  return (
    <div
      className={classes.card}
      onClick={() => navigate(`/cardDetail/${data?._id}`)}
    >
      <div className={classes.imgBox}>
        <img src={data?.image} />
      </div>
      <div className={classes.content}>
        <h4 className="t-t-c">{data?.title}</h4>
        <p>{data?.description}</p>
        <Button
          label={"View Card"}
          isRightArrow
          primary={true}
          className={classes.btn}
        />
      </div>
    </div>
  );
}

export default FeaturedCollectionCard;
